/* main.jsx — точка входа Vite (заменяет app.html: CDN React/Babel + длинный <script>-список).
 * Порядок: стили (как в <head> app.html, breakpoints — последним) → монтаж <App/>.
 * Слой данных — БОЕВОЙ (lib/api поверх apiFetch); мок-слой снят (см. _wiring/CONNECTION-PLAN).
 * ХЕНДОФФ: в боевом frontend стили мёржатся в свой слой, App берёт боевые контексты. */

// — стили (порядок важен; breakpoints перекрывает медиа-правила последним) —
import './styles/tokens.css';
import './styles/base.css';
import './styles/utilities.css';
import './styles/components.css';
import './styles/shell.css';
import './styles/screens.css';
import './styles/library.css';
import './styles/table.css';
import './styles/kitchen.css';
import './styles/pos-kitchen.css';
import './styles/pos-push.css';
import './styles/ttk-editor.css';
import './styles/versioning.css';
import './styles/ingredient-editor.css';
import './styles/menu-editor.css';
import './styles/chat.css';
import './styles/chat-blocks.css';
import './styles/canvas.css';
import './styles/analytics.css';
import './styles/iiko-pnl.css';
import './styles/iiko-abc.css';
import './styles/iiko-liquidity.css';
import './styles/iiko-overview.css';
import './styles/iiko-inventory.css';
import './styles/iiko-movement.css';
import './styles/analytics-plus.css';
import './styles/integrations-shared.css';
import './styles/report-table.css';
/* общий слой «Аналитики через интеграции» — ПОСЛЕ per-отчётных файлов:
   точечно перекрывает их своими карточками/таблицами/навигацией */
import './styles/analytics-redesign.css';
import './styles/restaurant.css';
import './styles/settings.css';
import './styles/checkout.css';
import './styles/notifications.css';
import './styles/auth.css';
import './styles/command-palette.css';
import './styles/onboarding.css';
import './styles/onboarding-module1.css';
import './styles/crm.css';
import './styles/tracker.css';
import './styles/broadcasts.css';
import './styles/business-demo.css';
import './styles/sales-console.css';
import './styles/payment-links.css';
import './styles/dealers.css';
import './styles/gift.css';
import './styles/academy.css';
import './styles/diploma.css';
import './styles/utm.css';
import './styles/breakpoints.css';
/* CSS, который подключают сами разделы (консоль «Академии», реестры «Продукции», столы Аналитики), —
   тоже здесь, ПОСЛЕ breakpoints.css и в том же порядке, что был до разбиения на чанки (iiko-tables.css
   и тогда шёл после общего CSS). Иначе он приходил бы только с чанком раздела, а Vite не повторяет
   упавшую загрузку CSS-зависимости: после сбоя сети на предзагрузке раздел молча рисовался бы без
   своих стилей. Новый файл стилей раздела — сюда же (сторож — app/lazyScreens.test.js). */
import './styles/academy-console.css';
import './styles/kitchen-cards.css';
import './styles/ttk-registry.css';
import './styles/menus-registry.css';
import './styles/pos-registry.css';
import './styles/iiko-tables.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.jsx';
import { installLinkPrefetch, preloadScreenFor } from './app/lazyScreens.js';

// Разделы — ленивыми чанками (app/lazyScreens.js). Чанк стартового адреса качаем сразу, ДО
// рендера: иначе его запрос ушёл бы только после ответа /api/auth/me (гард RequireAuth).
// Ссылки своего сайта подгружают чанк своего раздела при наведении, фокусе и касании.
preloadScreenFor(window.location.pathname);
installLinkPrefetch();

createRoot(document.getElementById('root')).render(<App />);
